import React from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const NewAnswer2 = ({answer, color}) => {

    let classColor = "timeline-step step2  badge-white bg-gradient-" + color;
    let classButton = "info offset-xl-2  bg-gradient-" + color + " border border-0 rounded-pill "
    let textColor = "questionFont2   text-" + color ;

  return (
    <div className=' '>
            <span className={classColor}>
                <i className="fa fa-question-circle" aria-hidden="true"></i>
            </span>
                <div className="timeline-content qCenter">
                    <h3 className="text-muted font-weight-bold  text-center textCard2">
                        <span className={textColor} style={{textTransform: 'capitalize'}}>
                            {answer.subjectname}
                        </span>
                    </h3>  
                    <LinkContainer to={`/studentwatchnew/${answer._id}`} className='btn btn-default cardBtn'>
                    <div className="icon-image-wrapper">    
                        <video 
                        src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/asnwers/${answer?.mediaId}`}
                        className='questImg4'
                        />
                        <i class="fa fa-play play-icon" ></i>
                        </div>      
                    </LinkContainer>                                    
                    <h6 className=" mt-2 mb-0 text-center cardDesc textCard">{answer.tittle}</h6>
                    <div className="mt-2 kanBtn answerBtn23">
                    <LinkContainer to={`/studentwatchnew/${answer._id}`} className='btn btn-default cardBtn cardBtn23 '>
                        <Button variant={classButton}> Watch Answer <i className="fa fa-play-circle" aria-hidden="true"></i>
                        </Button>
                    </LinkContainer>    
                    </div>   
            </div><br /><br /><br />                           
      
    </div> 
  )
}

export default NewAnswer2
